var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0H49.3333L40.2667 17L49.3333 34H4V48H0V34V0H4ZM42.6667 30H4V4H42.6667L35.7333 17L42.6667 30ZM29.9006 19.5845C30.5133 19.2257 30.8897 18.5689 30.8897 17.8588C30.8897 17.1488 30.5133 16.492 29.9006 16.1331L18.5115 9.46154C17.893 9.09924 17.128 9.09562 16.5061 9.45206C15.8842 9.80849 15.5006 10.4705 15.5006 11.1873V24.5304C15.5006 25.2472 15.8842 25.9092 16.5061 26.2656C17.128 26.622 17.893 26.6184 18.5115 26.2561L29.9006 19.5845ZM19.5006 21.041L19.5006 14.6767L24.9328 17.8588L19.5006 21.041Z",
    fill: "#3B3B3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion5);
export default __webpack_public_path__ + "static/media/union_5.a1016e88663d21cf68c686c5b3268b56.svg";
export { ForwardRef as ReactComponent };